query CompanyBase($id: String) {
  company(id: $id) {
    id
    slug
    country
    site {
      id
      url
    }
  }
}
